"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TeamIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative overflow-hidden bg-light-background py-16 md:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 opacity-5" style={{
      backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            currentColor 10px,
            currentColor 11px
          )`,
      transform: "translateY(calc(var(--scroll, 0) * -0.3px))"
    }} />

      <div className="container relative mx-auto px-6">
        <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          {}
          <h2 className="mb-4 text-center font-display text-3xl font-semibold text-foreground-light md:text-4xl lg:text-5xl">
            Meet Our Innovation Team
          </h2>

          {}
          <p className="mb-12 text-center font-sans text-base font-light leading-relaxed text-muted md:text-lg">
            Our dedicated experts bring decades of combined experience in materials science,
            product development, and intellectual property strategy to help your brand succeed.
          </p>

          {}
          <div className="w-full md:w-4/5">
            <div className="group relative overflow-hidden rounded-lg shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2.5 hover:shadow-medium">
              <img src="https://famous-marmoset.10web.cloud/wp-content/uploads/2026/04/Materials-testing-in-action.png" alt="Science-theme hero image" className="h-auto w-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}